import { render, staticRenderFns } from "./AlvarasView.vue?vue&type=template&id=1c4e3281&"
import script from "./AlvarasView.vue?vue&type=script&lang=js&"
export * from "./AlvarasView.vue?vue&type=script&lang=js&"
import style0 from "./AlvarasView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports